<template>
    <div></div>
</template>

<script>
import { environment } from "../../../environment/environment.js";

export default {
    name: "Application",
    data() {
        return {
            //sessionApp: {},
            session: {},
            environment: environment,
            applicationName: null,
            generalEx: {},
            applicationEx: {},
            appLogin: false,
            authentication: null,
        };
    },
    methods: {
        loadApplication() {
            this.generalEx = {};
            this.applicationEx = {};
            this.apiGetGeneralApplication({
                path: { applicationName: this.applicationName },
            })
                .then((dataRes) => {
                    this.session = this.validateApplicationSession(
                        this.applicationName,
                        dataRes,
                        true
                    );
                })
                .catch((errorRes) => {
                    this.clearSession(this.applicationName);
                    this.clearFrameworkSession();
                    if (errorRes.response.status == 403) {
                        this.launch();
                    } else {
                        this.goToErrorServiceUnavaliable({});
                    }
                });
        },

        launch() {
            this.validateFrameworkSession()
                .then(() => {
                    this.applicationName = this.$route.params.applicationName;
                    this.sessionGral = this.loadSession();
                    this.sessionApp = this.loadSession(this.applicationName);
                    this.loadApplication();
                })
                .catch(() => {
                    this.goToErrorUnauthorized({});
                });
        },
    },
    created() {
        this.launch();
    },
};
</script>

<style>
</style>